import { render, staticRenderFns } from "./columnRearrangeWithoutDynamic.vue?vue&type=template&id=24958794&"
import script from "./columnRearrangeWithoutDynamic.vue?vue&type=script&lang=js&"
export * from "./columnRearrangeWithoutDynamic.vue?vue&type=script&lang=js&"
import style0 from "./columnRearrangeWithoutDynamic.vue?vue&type=style&index=0&id=24958794&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports